module.exports = __webpack_public_path__ + "img/gallery-2.b7980ada.jpg";